import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';

@Component({
  selector: 'app-switch-number',
  templateUrl: './switch-number.component.html',
  styleUrls: ['./switch-number.component.scss']
})
export class SwitchNumberComponent extends ComponentBase implements OnInit {
  
  checked: AttributeModel;
  textNotChecked: string = "";

  constructor(private attributeService: AttributeService) { super() }

  ngOnInit() {
   
    this.textNotChecked  = this.getOptionByKey(this.attribute, "TextNotChecked");

    this.checked = this.attributeService.findBy("checked", this.attribute.attributes);

  }

  get isChecked(): boolean
  {
    if(!this.checked.value) {
      return false;
    }

    return this.checked.value.toLowerCase() == "true";
  }

  set value(checked: boolean)
  {
      this.checked.value = String(checked);
  }

  onValueChange(value: boolean) {

    this.attribute.value = null;

    this.checked.value = value.toString();
  }

  hasValue(): boolean {
    return this.attribute.value && this.attribute.value != ""
  }
}
